module.exports = __webpack_public_path__ + "static/d1-eba3ee022bb9838543b66f54c3524283.png";